import React from 'react';
import { Box } from '@mui/material';

function EmptyRobotBox() {
    return <Box display={{ xs: 'none', md: 'flex' }} className='step_empty_div' />;
}

export default EmptyRobotBox;
